import React, { useState, useEffect } from 'react';
import type { Person } from '../types/person';
import { peopleApi } from '../api';

interface PersonFormProps {
  person?: Person | null;
  onClose: () => void;
  onSubmit: () => void;
}

// 头像 Emoji 分类
const AVATAR_CATEGORIES: { label: string; icon: string; emojis: string[] }[] = [
  {
    label: '人物',
    icon: '😀',
    emojis: [
      '😀','😃','😄','😁','😆','😅','🤣','😂','🙂','🙃',
      '😉','😊','😇','🥰','😍','🤩','😘','😗','😚','😙',
      '🥲','😋','😛','😜','🤪','😝','🤑','🤗','🤭','🫢',
      '🤫','🤔','🫡','🤐','🤨','😐','😑','😶','🫥','😏',
      '😒','🙄','😬','🤥','😌','😔','😪','🤤','😴','😷',
      '🤒','🤕','🤢','🤮','🥵','🥶','🥴','😵','🤯','🤠',
      '🥳','🥸','😎','🤓','🧐','😕','🫤','😟','🙁','😮',
      '😯','😲','😳','🥺','🥹','😦','😧','😨','😰','😥',
      '😢','😭','😱','😖','😣','😞','😓','😩','😫','🥱',
      '😤','😡','😠','🤬','😈','👿','💀','☠️','💩','🤡',
      '👹','👺','👻','👽','👾','🤖',
    ],
  },
  {
    label: '角色',
    icon: '👤',
    emojis: [
      '👶','👧','🧒','👦','👩','🧑','👨','👩‍🦱','🧑‍🦱','👨‍🦱',
      '👩‍🦰','🧑‍🦰','👨‍🦰','👱‍♀️','👱','👱‍♂️','👩‍🦳','🧑‍🦳','👨‍🦳','👩‍🦲',
      '🧑‍🦲','👨‍🦲','🧔‍♀️','🧔','🧔‍♂️','👵','🧓','👴','👲','👳‍♀️',
      '👳','👳‍♂️','🧕','👮‍♀️','👮','👮‍♂️','👷‍♀️','👷','👷‍♂️','💂‍♀️',
      '💂','💂‍♂️','🕵️‍♀️','🕵️','🕵️‍♂️','👩‍⚕️','🧑‍⚕️','👨‍⚕️','👩‍🌾','🧑‍🌾',
      '👨‍🌾','👩‍🍳','🧑‍🍳','👨‍🍳','👩‍🎓','🧑‍🎓','👨‍🎓','👩‍🎤','🧑‍🎤','👨‍🎤',
      '👩‍🏫','🧑‍🏫','👨‍🏫','👩‍🏭','🧑‍🏭','👨‍🏭','👩‍💻','🧑‍💻','👨‍💻','👩‍💼',
      '🧑‍💼','👨‍💼','👩‍🔧','🧑‍🔧','👨‍🔧','👩‍🔬','🧑‍🔬','👨‍🔬','👩‍🎨','🧑‍🎨',
      '👨‍🎨','👩‍🚒','🧑‍🚒','👨‍🚒','👩‍✈️','🧑‍✈️','👨‍✈️','👩‍🚀','🧑‍🚀','👨‍🚀',
      '👩‍⚖️','🧑‍⚖️','👨‍⚖️','🤴','👸','🥷','🦸‍♀️','🦸','🦸‍♂️','🦹‍♀️',
      '🦹','🦹‍♂️','🧙‍♀️','🧙','🧙‍♂️','🧚‍♀️','🧚','🧚‍♂️','🧛‍♀️','🧛',
      '🧛‍♂️','🧜‍♀️','🧜','🧜‍♂️','🧝‍♀️','🧝','🧝‍♂️','🧞‍♀️','🧞','🧞‍♂️',
    ],
  },
  {
    label: '动物',
    icon: '🐱',
    emojis: [
      '🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐻‍❄️','🐨',
      '🐯','🦁','🐮','🐷','🐸','🐵','🙈','🙉','🙊','🐒',
      '🐔','🐧','🐦','🐤','🐣','🐥','🦆','🦅','🦉','🦇',
      '🐺','🐗','🐴','🦄','🐝','🪱','🐛','🦋','🐌','🐞',
      '🐜','🪰','🪲','🪳','🦟','🦗','🕷️','🦂','🐢','🐍',
      '🦎','🦖','🦕','🐙','🦑','🦐','🦞','🦀','🐡','🐠',
      '🐟','🐬','🐳','🐋','🦈','🐊','🐅','🐆','🦓','🦍',
      '🦧','🐘','🦛','🦏','🐪','🐫','🦒','🦘','🦬','🐃',
      '🐂','🐄','🐎','🐖','🐏','🐑','🦙','🐐','🦌','🐕',
      '🐩','🦮','🐕‍🦺','🐈','🐈‍⬛','🪶','🐓','🦃','🦤','🦚',
      '🦜','🦢','🦩','🕊️','🐇','🦝','🦨','🦡','🦫','🦦',
      '🦥','🐁','🐀','🐿️','🦔',
    ],
  },
  {
    label: '自然',
    icon: '🌸',
    emojis: [
      '🌵','🎄','🌲','🌳','🌴','🪵','🌱','🌿','☘️','🍀',
      '🎍','🪴','🎋','🍃','🍂','🍁','🪺','🪹','🍄','🌾',
      '💐','🌷','🌹','🥀','🌺','🌸','🌼','🌻','🌞','🌝',
      '🌛','🌜','🌚','🌕','🌖','🌗','🌘','🌑','🌒','🌓',
      '🌔','🌙','🌎','🌍','🌏','🪐','💫','⭐','🌟','✨',
      '⚡','☄️','💥','🔥','🌪️','🌈','☀️','🌤️','⛅','🌥️',
      '☁️','🌦️','🌧️','⛈️','🌩️','🌨️','❄️','☃️','⛄','🌬️',
      '💨','💧','💦','🫧','☔','☂️','🌊','🌫️',
    ],
  },
  {
    label: '食物',
    icon: '🍕',
    emojis: [
      '🍏','🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🫐',
      '🍈','🍒','🍑','🥭','🍍','🥥','🥝','🍅','🍆','🥑',
      '🥦','🥬','🥒','🌶️','🫑','🌽','🥕','🫒','🧄','🧅',
      '🥔','🍠','🫘','🥐','🥯','🍞','🥖','🥨','🧀','🥚',
      '🍳','🧈','🥞','🧇','🥓','🥩','🍗','🍖','🦴','🌭',
      '🍔','🍟','🍕','🫓','🥪','🥙','🧆','🌮','🌯','🫔',
      '🥗','🥘','🫕','🥫','🍝','🍜','🍲','🍛','🍣','🍱',
      '🥟','🦪','🍤','🍙','🍚','🍘','🍥','🥠','🥮','🍢',
      '🍡','🍧','🍨','🍦','🥧','🧁','🍰','🎂','🍮','🍭',
      '🍬','🍫','🍿','🍩','🍪','🌰','🥜','🍯','🥛','🍼',
      '🫖','☕','🍵','🧃','🥤','🧋','🍶','🍺','🍻','🥂',
      '🍷','🥃','🍸','🍹','🧉','🍾','🧊',
    ],
  },
  {
    label: '运动',
    icon: '⚽',
    emojis: [
      '⚽','🏀','🏈','⚾','🥎','🎾','🏐','🏉','🥏','🎱',
      '🪀','🏓','🏸','🏒','🏑','🥍','🏏','🪃','🥅','⛳',
      '🪁','🏹','🎣','🤿','🥊','🥋','🎽','🛹','🛼','🛷',
      '⛸️','🥌','🎿','⛷️','🏂','🪂','🏋️‍♀️','🏋️','🤸‍♀️','🤸',
      '⛹️‍♀️','⛹️','🤺','🤾‍♀️','🤾','🏌️‍♀️','🏌️','🏇','🧘‍♀️','🧘',
      '🏄‍♀️','🏄','🏊‍♀️','🏊','🤽‍♀️','🤽','🚣‍♀️','🚣','🧗‍♀️','🧗',
      '🚵‍♀️','🚵','🚴‍♀️','🚴','🏆','🥇','🥈','🥉','🏅','🎖️',
      '🏵️','🎗️','🎫','🎟️',
    ],
  },
  {
    label: '物品',
    icon: '💎',
    emojis: [
      '💎','💍','👑','🎩','🧢','👓','🕶️','🥽','🎒','👜',
      '👝','👛','💼','🎓','⛑️','📿','💄','💅','🔮','🧿',
      '🪬','📱','💻','⌨️','🖥️','🖨️','🖱️','🖲️','🕹️','🗜️',
      '💾','💿','📀','📷','📸','📹','🎥','📽️','🎞️','📞',
      '☎️','📟','📠','📺','📻','🎙️','🎚️','🎛️','🧭','⏱️',
      '⏲️','⏰','🕰️','⌛','📡','🔋','🪫','🔌','💡','🔦',
      '🕯️','🪔','🧯','🛢️','💸','💵','💴','💶','💷','🪙',
      '💰','🏠','🏡','🏢','🏣','🏤','🏥','🏦','🏨','🏩',
      '🏪','🏫','🏬','🏭','🏯','🏰','💒','🗼','🗽','⛪',
      '🕌','🛕','🕍','⛩️','🕋',
    ],
  },
  {
    label: '符号',
    icon: '❤️',
    emojis: [
      '❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔',
      '❤️‍🔥','❤️‍🩹','❣️','💕','💞','💓','💗','💖','💘','💝',
      '⭐','🌟','💫','✨','⚡','🔥','💥','❄️','🌈','☀️',
      '🌙','🎵','🎶','🎼','🎹','🥁','🎷','🎺','🎸','🪕',
      '🎻','🎬','🎨','🎭','🎪','🎤','🎧','📚','📖','📝',
      '✏️','🖊️','🖋️','✒️','📌','📍','🔑','🗝️','🔒','🔓',
      '🛡️','⚔️','🏹','🔱','⚜️','🏴','🚩','🏳️','🏳️‍🌈','🏴‍☠️',
      '♠️','♥️','♦️','♣️','🃏','🀄','🎴','🎯','🎲','🧩',
      '♟️','🪄','🧸','🪅','🪆','🎀','🎁','🎈','🎉','🎊',
    ],
  },
];

const PRESET_COLORS = [
  '#6C5CE7', '#A29BFE', '#0984E3', '#74B9FF', '#00CEC9',
  '#00B894', '#FDCB6E', '#E17055', '#FF6B6B', '#FD79A8',
  '#636E72', '#2D3436',
];

const RELATIONSHIP_PRESETS = ['朋友', '同事', '家人', '同学', '恋人', '邻居', '客户', '老师'];

const PersonForm: React.FC<PersonFormProps> = ({ person, onClose, onSubmit }) => {
  const [name, setName] = useState('');
  const [relationship_type, setRelationshipType] = useState('');
  const [notes, setNotes] = useState('');
  const [avatar, setAvatar] = useState('');
  const [level, setLevel] = useState(1);
  const [color, setColor] = useState('#6C5CE7');
  const [tags, setTags] = useState('');
  const [friendly, setFriendly] = useState(50);
  const [trust, setTrust] = useState(50);
  const [birthday, setBirthday] = useState('');
  const [loading, setLoading] = useState(false);
  const [activeSection, setActiveSection] = useState<'basic' | 'attributes' | 'extra'>('basic');
  const [showAvatarPicker, setShowAvatarPicker] = useState(false);
  const [avatarCategory, setAvatarCategory] = useState(0);

  useEffect(() => {
    if (person) {
      setName(person.name);
      setRelationshipType(person.relationship_type || '');
      setNotes(person.notes || '');
      setAvatar(person.avatar || '');
      setLevel(person.level || 1);
      setColor(person.color || '#6C5CE7');
      setTags((person.tags || []).join(', '));
      setFriendly(person.attributes?.友好度 || 50);
      setTrust(person.attributes?.信任度 || 50);
      setBirthday(person.attributes?.birthday || '');
    }
  }, [person]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      alert('请输入姓名');
      return;
    }

    setLoading(true);
    try {
      const tagsArray = tags.split(',').map(t => t.trim()).filter(t => t);
      const attributes: Record<string, any> = {
        友好度: friendly,
        信任度: trust,
      };
      if (birthday) attributes.birthday = birthday;

      const data: any = {
        name: name.trim(),
      };

      if (relationship_type) data.relationship_type = relationship_type;
      if (notes) data.notes = notes;
      if (avatar) data.avatar = avatar;
      if (level) data.level = level;
      if (color) data.color = color;
      if (tagsArray.length > 0) data.tags = tagsArray;
      if (attributes) data.attributes = attributes;

      if (person) {
        await peopleApi.update(person.id, data);
      } else {
        await peopleApi.create(data);
      }
      
      setName('');
      setRelationshipType('');
      setNotes('');
      setAvatar('');
      setLevel(1);
      setColor('#6C5CE7');
      setTags('');
      setFriendly(50);
      setTrust(50);
      setBirthday('');
      
      onSubmit();
    } catch (error: any) {
      console.error('操作失败:', error);
      const responseData = error?.response?.data;
      const detailMessage =
        responseData?.detail ||
        (typeof responseData === 'string'
          ? responseData
          : responseData && typeof responseData === 'object'
            ? JSON.stringify(responseData)
            : null);
      const errorMsg = detailMessage || error.message || '未知错误';
      const requestUrl = `${error?.config?.baseURL || ''}${error?.config?.url || ''}`;
      alert(`操作失败: ${errorMsg}${requestUrl ? `\n请求地址: ${requestUrl}` : ''}`);
    } finally {
      setLoading(false);
    }
  };

  const getFriendlyLabel = (value: number) => {
    if (value >= 80) return '非常友好 😊';
    if (value >= 60) return '友好 🙂';
    if (value >= 40) return '一般 😐';
    if (value >= 20) return '冷淡 😕';
    return '疏远 😶';
  };

  const getTrustLabel = (value: number) => {
    if (value >= 80) return '完全信任 🤝';
    if (value >= 60) return '比较信任 👍';
    if (value >= 40) return '一般 🤔';
    if (value >= 20) return '有所保留 😐';
    return '不太信任 🤨';
  };

  return (
    <div className="pform-overlay" onClick={onClose}>
      <div className="pform-modal" onClick={(e) => e.stopPropagation()}>
        {/* 头部 */}
        <div className="pform-header">
          <div className="pform-header-left">
            <div className="pform-header-icon" style={{ background: color }}>
              {avatar || name?.charAt(0) || '👤'}
            </div>
            <div>
              <h2 className="pform-title">{person ? '编辑联系人' : '添加新联系人'}</h2>
              <p className="pform-subtitle">{person ? '修改联系人信息' : '记录一位新的联系人'}</p>
            </div>
          </div>
          <button className="pform-close" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
            </svg>
          </button>
        </div>

        {/* 分段选择器 */}
        <div className="pform-segments">
          <button 
            className={`pform-segment ${activeSection === 'basic' ? 'active' : ''}`}
            onClick={() => setActiveSection('basic')}
          >
            基本信息
          </button>
          <button 
            className={`pform-segment ${activeSection === 'attributes' ? 'active' : ''}`}
            onClick={() => setActiveSection('attributes')}
          >
            关系属性
          </button>
          <button 
            className={`pform-segment ${activeSection === 'extra' ? 'active' : ''}`}
            onClick={() => setActiveSection('extra')}
          >
            更多设置
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          {/* 基本信息 */}
          <div className="pform-section" style={{ display: activeSection === 'basic' ? 'block' : 'none' }}>
            <div className="pform-field">
              <label className="pform-label">
                姓名 <span className="pform-required">*</span>
              </label>
              <input
                type="text"
                className="pform-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                placeholder="输入联系人姓名"
                autoFocus
              />
            </div>

            <div className="pform-field">
              <label className="pform-label">关系类型</label>
              <div className="pform-relation-presets">
                {RELATIONSHIP_PRESETS.map(type => (
                  <button
                    key={type}
                    type="button"
                    className={`pform-preset-chip ${relationship_type === type ? 'active' : ''}`}
                    onClick={() => setRelationshipType(relationship_type === type ? '' : type)}
                  >
                    {type}
                  </button>
                ))}
              </div>
              <input
                type="text"
                className="pform-input"
                value={relationship_type}
                onChange={(e) => setRelationshipType(e.target.value)}
                placeholder="或自定义关系类型..."
                style={{ marginTop: '8px' }}
              />
            </div>

            <div className="pform-field">
              <label className="pform-label">头像图标</label>
              <div className="pform-avatar-section">
                <button
                  type="button"
                  className="pform-avatar-preview"
                  style={{ background: color }}
                  onClick={() => setShowAvatarPicker(!showAvatarPicker)}
                >
                  <span className="pform-avatar-emoji">{avatar || '👤'}</span>
                  <span className="pform-avatar-edit-hint">点击选择</span>
                </button>
                {avatar && (
                  <button
                    type="button"
                    className="pform-avatar-clear"
                    onClick={() => setAvatar('')}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
                    </svg>
                    清除
                  </button>
                )}
              </div>
              {showAvatarPicker && (
                <div className="pform-emoji-picker" onClick={(e) => e.stopPropagation()}>
                  <div className="pform-emoji-tabs">
                    {AVATAR_CATEGORIES.map((cat, idx) => (
                      <button
                        key={cat.label}
                        type="button"
                        className={`pform-emoji-tab ${avatarCategory === idx ? 'active' : ''}`}
                        onClick={() => setAvatarCategory(idx)}
                        title={cat.label}
                      >
                        {cat.icon}
                      </button>
                    ))}
                  </div>
                  <div className="pform-emoji-category-label">{AVATAR_CATEGORIES[avatarCategory].label}</div>
                  <div className="pform-emoji-grid">
                    {AVATAR_CATEGORIES[avatarCategory].emojis.map((emoji, idx) => (
                      <button
                        key={idx}
                        type="button"
                        className={`pform-emoji-item ${avatar === emoji ? 'selected' : ''}`}
                        onClick={(e) => { e.stopPropagation(); setAvatar(emoji); setShowAvatarPicker(false); }}
                      >
                        {emoji}
                      </button>
                    ))}
                  </div>
                  <div className="pform-emoji-custom">
                    <input
                      type="text"
                      className="pform-input"
                      value={avatar}
                      onChange={(e) => setAvatar(e.target.value)}
                      placeholder="或输入自定义文字..."
                      style={{ fontSize: '13px', padding: '8px 12px' }}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="pform-field">
              <label className="pform-label">备注</label>
              <textarea
                className="pform-textarea"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="添加一些备注信息..."
                rows={3}
              />
            </div>

            <div className="pform-field">
              <label className="pform-label">生日</label>
              <input
                type="date"
                className="pform-input"
                value={birthday}
                onChange={(e) => setBirthday(e.target.value)}
              />
            </div>
          </div>

          {/* 关系属性 */}
          <div className="pform-section" style={{ display: activeSection === 'attributes' ? 'block' : 'none' }}>
            <div className="pform-field">
              <div className="pform-slider-header">
                <label className="pform-label" style={{ marginBottom: 0 }}>友好度</label>
                <span className="pform-slider-value" style={{ color: friendly >= 60 ? 'var(--success)' : friendly >= 40 ? 'var(--warning)' : 'var(--danger)' }}>
                  {friendly}%
                </span>
              </div>
              <div className="pform-slider-desc">{getFriendlyLabel(friendly)}</div>
              <input
                type="range"
                className="pform-range"
                min="0"
                max="100"
                value={friendly}
                onChange={(e) => setFriendly(Number(e.target.value))}
                style={{
                  background: `linear-gradient(to right, var(--primary) 0%, var(--primary) ${friendly}%, var(--border) ${friendly}%, var(--border) 100%)`
                }}
              />
            </div>

            <div className="pform-field">
              <div className="pform-slider-header">
                <label className="pform-label" style={{ marginBottom: 0 }}>信任度</label>
                <span className="pform-slider-value" style={{ color: trust >= 60 ? 'var(--success)' : trust >= 40 ? 'var(--warning)' : 'var(--danger)' }}>
                  {trust}%
                </span>
              </div>
              <div className="pform-slider-desc">{getTrustLabel(trust)}</div>
              <input
                type="range"
                className="pform-range"
                min="0"
                max="100"
                value={trust}
                onChange={(e) => setTrust(Number(e.target.value))}
                style={{
                  background: `linear-gradient(to right, var(--accent) 0%, var(--accent) ${trust}%, var(--border) ${trust}%, var(--border) 100%)`
                }}
              />
            </div>

            <div className="pform-field">
              <label className="pform-label">等级</label>
              <div className="pform-level-picker">
                <button 
                  type="button" 
                  className="pform-level-btn"
                  onClick={() => setLevel(Math.max(1, level - 1))}
                >
                  −
                </button>
                <div className="pform-level-display">
                  <span className="pform-level-number">Lv.{level}</span>
                </div>
                <button 
                  type="button" 
                  className="pform-level-btn"
                  onClick={() => setLevel(Math.min(100, level + 1))}
                >
                  +
                </button>
              </div>
            </div>
          </div>

          {/* 更多设置 */}
          <div className="pform-section" style={{ display: activeSection === 'extra' ? 'block' : 'none' }}>
            <div className="pform-field">
              <label className="pform-label">显示颜色</label>
              <div className="pform-color-grid">
                {PRESET_COLORS.map(c => (
                  <button
                    key={c}
                    type="button"
                    className={`pform-color-swatch ${color === c ? 'active' : ''}`}
                    style={{ background: c }}
                    onClick={() => setColor(c)}
                  >
                    {color === c && (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 6 9 17l-5-5"/>
                      </svg>
                    )}
                  </button>
                ))}
                <label className="pform-color-custom">
                  <input
                    type="color"
                    value={color}
                    onChange={(e) => setColor(e.target.value)}
                    style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }}
                  />
                  <span className="pform-color-custom-inner" style={{ borderColor: color }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 5v14"/><path d="M5 12h14"/>
                    </svg>
                  </span>
                </label>
              </div>
            </div>

            <div className="pform-field">
              <label className="pform-label">标签</label>
              <input
                type="text"
                className="pform-input"
                value={tags}
                onChange={(e) => setTags(e.target.value)}
                placeholder="用逗号分隔，例如：重要, 工作, 朋友"
              />
              {tags && (
                <div className="pform-tags-preview">
                  {tags.split(',').map(t => t.trim()).filter(t => t).map((tag, i) => (
                    <span key={i} className="pform-tag-preview">{tag}</span>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* 底部操作 */}
          <div className="pform-footer">
            <button type="button" className="pform-btn-cancel" onClick={onClose}>
              取消
            </button>
            <button type="submit" className="pform-btn-submit" disabled={loading} style={{ background: color }}>
              {loading ? (
                <>
                  <span className="pform-spinner" />
                  保存中...
                </>
              ) : (
                <>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 6 9 17l-5-5"/>
                  </svg>
                  {person ? '保存修改' : '创建联系人'}
                </>
              )}
            </button>
          </div>
        </form>
      </div>

      <style>{`
        .pform-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.45);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 16px;
          animation: overlayIn 200ms var(--ease-out);
        }

        @keyframes overlayIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .pform-modal {
          background: var(--surface);
          border-radius: var(--radius-2xl);
          max-width: 520px;
          width: 100%;
          max-height: 85vh;
          overflow-y: auto;
          animation: modalIn 300ms var(--ease-spring);
          box-shadow: var(--shadow-xl);
        }

        @keyframes modalIn {
          from { opacity: 0; transform: translateY(20px) scale(0.96); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }

        /* Header */
        .pform-header {
          position: sticky;
          top: 0;
          z-index: 2;
          background: var(--surface);
          padding-top: calc(16px + var(--safe-area-top, 0px));
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: 24px;
          padding-right: 24px;
          padding-bottom: 12px;
          border-bottom: 1px solid var(--border-light);
        }

        .pform-header-left {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .pform-header-icon {
          width: 44px;
          height: 44px;
          border-radius: var(--radius-lg);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 20px;
          font-weight: 600;
          flex-shrink: 0;
        }

        .pform-title {
          margin: 0;
          font-size: 18px;
          font-weight: 700;
          color: var(--text-primary);
          letter-spacing: -0.01em;
        }

        .pform-subtitle {
          margin: 2px 0 0;
          font-size: 13px;
          color: var(--text-tertiary);
        }

        .pform-close {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border: none;
          background: var(--surface-hover);
          border-radius: var(--radius-full);
          color: var(--text-secondary);
          cursor: pointer;
          transition: all var(--duration-fast);
          flex-shrink: 0;
        }

        .pform-close:hover {
          background: var(--border);
          color: var(--text-primary);
        }

        /* Segments */
        .pform-segments {
          display: flex;
          gap: 4px;
          margin: 14px 24px 0;
          padding: 4px;
          background: var(--surface-hover);
          border-radius: var(--radius-md);
        }

        .pform-segment {
          flex: 1;
          padding: 9px 12px;
          border: none;
          background: none;
          font-size: 13px;
          font-weight: 500;
          font-family: inherit;
          color: var(--text-tertiary);
          cursor: pointer;
          border-radius: var(--radius-sm);
          transition: all var(--duration-normal) var(--ease-out);
          text-align: center;
        }

        .pform-segment.active {
          background: var(--surface);
          color: var(--primary);
          box-shadow: var(--shadow-sm);
          font-weight: 600;
        }

        /* Section */
        .pform-section {
          padding: 20px 24px 0;
        }

        /* Field */
        .pform-field {
          margin-bottom: 20px;
        }

        .pform-label {
          display: block;
          margin-bottom: 8px;
          font-size: 13px;
          font-weight: 600;
          color: var(--text-secondary);
        }

        .pform-required {
          color: var(--danger);
        }

        .pform-input {
          width: 100%;
          padding: 12px 16px;
          border: 1.5px solid var(--border);
          border-radius: var(--radius-md);
          font-size: 15px;
          font-family: inherit;
          color: var(--text-primary);
          background: var(--surface);
          transition: all var(--duration-fast);
          box-sizing: border-box;
        }

        .pform-input:focus {
          outline: none;
          border-color: var(--primary);
          box-shadow: 0 0 0 3px var(--primary-bg);
        }

        .pform-input::placeholder {
          color: var(--text-tertiary);
        }

        .pform-textarea {
          width: 100%;
          padding: 12px 16px;
          border: 1.5px solid var(--border);
          border-radius: var(--radius-md);
          font-size: 15px;
          font-family: inherit;
          color: var(--text-primary);
          background: var(--surface);
          transition: all var(--duration-fast);
          resize: vertical;
          min-height: 80px;
          line-height: 1.6;
          box-sizing: border-box;
        }

        .pform-textarea:focus {
          outline: none;
          border-color: var(--primary);
          box-shadow: 0 0 0 3px var(--primary-bg);
        }

        .pform-textarea::placeholder {
          color: var(--text-tertiary);
        }

        /* Avatar Picker */
        .pform-avatar-section {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .pform-avatar-preview {
          width: 64px;
          height: 64px;
          border-radius: var(--radius-xl);
          border: none;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all var(--duration-fast);
          position: relative;
          overflow: hidden;
          box-shadow: var(--shadow-md);
        }

        .pform-avatar-preview:active {
          transform: scale(0.92);
        }

        .pform-avatar-emoji {
          font-size: 32px;
          line-height: 1;
          filter: drop-shadow(0 1px 2px rgba(0,0,0,0.1));
        }

        .pform-avatar-edit-hint {
          font-size: 9px;
          color: rgba(255,255,255,0.85);
          font-weight: 600;
          margin-top: 2px;
          letter-spacing: 0.02em;
        }

        .pform-avatar-clear {
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 6px 12px;
          border: 1.5px solid var(--border);
          border-radius: var(--radius-full);
          background: var(--surface);
          font-size: 12px;
          font-weight: 500;
          font-family: inherit;
          color: var(--text-tertiary);
          cursor: pointer;
          transition: all var(--duration-fast);
        }

        .pform-avatar-clear:hover {
          border-color: var(--danger);
          color: var(--danger);
          background: var(--danger-bg);
        }

        /* Emoji Picker */
        .pform-emoji-picker {
          margin-top: 12px;
          border: 1.5px solid var(--border);
          border-radius: var(--radius-lg);
          background: var(--surface);
          overflow: hidden;
          animation: emojiPickerIn 200ms var(--ease-out);
        }

        @keyframes emojiPickerIn {
          from { opacity: 0; transform: translateY(-6px); max-height: 0; }
          to { opacity: 1; transform: translateY(0); max-height: 400px; }
        }

        .pform-emoji-tabs {
          display: flex;
          gap: 2px;
          padding: 6px 8px;
          border-bottom: 1px solid var(--border-light);
          background: var(--surface-hover);
          overflow-x: auto;
          scrollbar-width: none;
        }

        .pform-emoji-tabs::-webkit-scrollbar {
          display: none;
        }

        .pform-emoji-tab {
          flex-shrink: 0;
          width: 36px;
          height: 32px;
          border: none;
          background: none;
          font-size: 18px;
          cursor: pointer;
          border-radius: var(--radius-sm);
          transition: all var(--duration-fast);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0.6;
        }

        .pform-emoji-tab:hover {
          opacity: 0.9;
          background: var(--surface);
        }

        .pform-emoji-tab.active {
          opacity: 1;
          background: var(--surface);
          box-shadow: var(--shadow-sm);
        }

        .pform-emoji-category-label {
          padding: 8px 12px 4px;
          font-size: 11px;
          font-weight: 600;
          color: var(--text-tertiary);
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .pform-emoji-grid {
          display: grid;
          grid-template-columns: repeat(8, 1fr);
          gap: 2px;
          padding: 4px 8px;
          max-height: 220px;
          overflow-y: auto;
          scrollbar-width: thin;
        }

        .pform-emoji-grid::-webkit-scrollbar {
          width: 4px;
        }

        .pform-emoji-grid::-webkit-scrollbar-thumb {
          background: var(--border);
          border-radius: 2px;
        }

        .pform-emoji-item {
          width: 100%;
          aspect-ratio: 1;
          border: none;
          background: none;
          font-size: 22px;
          cursor: pointer;
          border-radius: var(--radius-sm);
          transition: all var(--duration-fast);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
        }

        .pform-emoji-item:hover {
          background: var(--surface-hover);
          transform: scale(1.15);
        }

        .pform-emoji-item:active {
          transform: scale(0.9);
        }

        .pform-emoji-item.selected {
          background: var(--primary-bg);
          box-shadow: inset 0 0 0 2px var(--primary);
          border-radius: var(--radius-md);
        }

        .pform-emoji-custom {
          padding: 8px;
          border-top: 1px solid var(--border-light);
        }

        /* Relation presets */
        .pform-relation-presets {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .pform-preset-chip {
          padding: 7px 14px;
          border: 1.5px solid var(--border);
          border-radius: var(--radius-full);
          background: var(--surface);
          font-size: 13px;
          font-weight: 500;
          font-family: inherit;
          color: var(--text-secondary);
          cursor: pointer;
          transition: all var(--duration-fast);
        }

        .pform-preset-chip:active {
          transform: scale(0.95);
        }

        .pform-preset-chip.active {
          border-color: var(--primary);
          background: var(--primary-bg);
          color: var(--primary);
          font-weight: 600;
        }

        /* Slider */
        .pform-slider-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 4px;
        }

        .pform-slider-value {
          font-size: 16px;
          font-weight: 700;
        }

        .pform-slider-desc {
          font-size: 12px;
          color: var(--text-tertiary);
          margin-bottom: 12px;
        }

        .pform-range {
          width: 100%;
          height: 6px;
          border-radius: var(--radius-full);
          outline: none;
          -webkit-appearance: none;
          appearance: none;
          cursor: pointer;
        }

        .pform-range::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          background: white;
          border: 3px solid var(--primary);
          box-shadow: 0 2px 8px rgba(0,0,0,0.15);
          cursor: pointer;
          transition: transform var(--duration-fast);
        }

        .pform-range::-webkit-slider-thumb:active {
          transform: scale(1.2);
        }

        /* Level picker */
        .pform-level-picker {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .pform-level-btn {
          width: 40px;
          height: 40px;
          border: 1.5px solid var(--border);
          border-radius: var(--radius-md);
          background: var(--surface);
          font-size: 20px;
          font-weight: 500;
          color: var(--text-secondary);
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all var(--duration-fast);
          font-family: inherit;
        }

        .pform-level-btn:active {
          transform: scale(0.9);
          background: var(--surface-hover);
        }

        .pform-level-display {
          flex: 1;
          text-align: center;
        }

        .pform-level-number {
          font-size: 24px;
          font-weight: 700;
          color: var(--primary);
        }

        /* Color grid */
        .pform-color-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }

        .pform-color-swatch {
          width: 36px;
          height: 36px;
          border-radius: var(--radius-md);
          border: 2px solid transparent;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all var(--duration-fast);
          box-shadow: var(--shadow-sm);
        }

        .pform-color-swatch:active {
          transform: scale(0.9);
        }

        .pform-color-swatch.active {
          border-color: white;
          box-shadow: 0 0 0 2px var(--text-primary), var(--shadow-sm);
          transform: scale(1.1);
        }

        .pform-color-custom {
          cursor: pointer;
        }

        .pform-color-custom-inner {
          width: 36px;
          height: 36px;
          border-radius: var(--radius-md);
          border: 2px dashed;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all var(--duration-fast);
        }

        /* Tags preview */
        .pform-tags-preview {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          margin-top: 10px;
        }

        .pform-tag-preview {
          font-size: 12px;
          padding: 4px 12px;
          border-radius: var(--radius-full);
          background: var(--primary-bg);
          color: var(--primary);
          font-weight: 500;
        }

        /* Footer */
        .pform-footer {
          position: sticky;
          bottom: 0;
          z-index: 2;
          display: flex;
          gap: 10px;
          padding: 14px 24px calc(14px + var(--safe-area-bottom, 0px));
          justify-content: flex-end;
          background: linear-gradient(180deg, rgba(0,0,0,0) 0%, var(--surface) 35%);
          border-top: 1px solid var(--border-light);
        }

        .pform-btn-cancel {
          padding: 12px 24px;
          border: 1.5px solid var(--border);
          border-radius: var(--radius-lg);
          background: var(--surface);
          font-size: 14px;
          font-weight: 600;
          font-family: inherit;
          color: var(--text-secondary);
          cursor: pointer;
          transition: all var(--duration-fast);
        }

        .pform-btn-cancel:hover {
          background: var(--surface-hover);
        }

        .pform-btn-cancel:active {
          transform: scale(0.96);
        }

        .pform-btn-submit {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 12px 28px;
          border: none;
          border-radius: var(--radius-lg);
          color: white;
          font-size: 14px;
          font-weight: 600;
          font-family: inherit;
          cursor: pointer;
          box-shadow: var(--shadow-primary);
          transition: all var(--duration-normal) var(--ease-out);
        }

        .pform-btn-submit:hover {
          opacity: 0.9;
        }

        .pform-btn-submit:active {
          transform: scale(0.96);
        }

        .pform-btn-submit:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .pform-spinner {
          width: 16px;
          height: 16px;
          border: 2px solid rgba(255,255,255,0.3);
          border-top-color: white;
          border-radius: 50%;
          animation: spin 0.6s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* Responsive */
        @media (max-width: 480px) {
          .pform-modal {
            max-height: 90vh;
            border-radius: var(--radius-xl) var(--radius-xl) 0 0;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            max-width: 100%;
            animation: slideUpModal 300ms var(--ease-spring);
          }

          @keyframes slideUpModal {
            from { transform: translateY(100%); }
            to { transform: translateY(0); }
          }

          .pform-overlay {
            align-items: flex-end;
            padding: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default PersonForm;
